import React, { useCallback, useContext } from 'react';

import { HSTableContext } from '../../../../Common/Table/HSTable/hs-table.context';
import { ActionContext } from '../../action.context';
import ActionsFormDialog from '../Form';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData } = useContext(ActionContext);
  const { refresh } = useContext(HSTableContext);

  const closeDialog = useCallback(
    async (success: boolean) => {
      if (success) {
        await refresh();
      }
      setEditDialogOpened(false);
    },
    [refresh, setEditDialogOpened]
  );

  return <ActionsFormDialog open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
